const ProcessStep = ({ number, title, description }: { number: number, title: string, description: string }) => {
  return (
    <div className="relative">
      <div className="bg-white p-6 rounded-lg shadow-md transition hover:shadow-lg text-center h-full flex flex-col">
        <div className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-4 z-10 relative">
          <span className="font-bold">{number}</span>
        </div>
        <h3 className="text-xl font-semibold mb-3 font-heading">{title}</h3>
        <p className="text-neutral-700 flex-grow">{description}</p>
      </div>
    </div>
  );
};

const ProcessSection = () => {
  const processes = [
    {
      title: "Research & Development",
      description: "Developing robust seed varieties through scientific breeding programs."
    },
    {
      title: "Controlled Cultivation",
      description: "Growing seeds in optimal conditions for maximum genetic potential."
    },
    {
      title: "Quality Processing",
      description: "Advanced cleaning, sorting, and treatment for perfect seed quality."
    },
    {
      title: "Rigorous Testing",
      description: "Thorough testing for germination rate, purity, and vigor before packaging."
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-primary font-medium">Our Process</span>
          <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-4 font-heading">
            From Cultivation to Packaging
          </h2>
          <p className="text-neutral-700">
            Every seed undergoes a meticulous process to ensure the highest 
            quality before reaching farmers' hands.
          </p>
        </div>
        
        <div className="relative">
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-neutral-200 -translate-y-1/2"></div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {processes.map((process, index) => (
              <ProcessStep 
                key={index}
                number={index + 1}
                title={process.title}
                description={process.description}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
